import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
const LazyLeftMenuDesktop = /*#__PURE__*/ lazy(()=>import("./LeftMenuDesktop.js"));
const LeftMenuDesktop = (props)=>/*#__PURE__*/ jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ jsx(LazyLeftMenuDesktop, {
            ...props
        })
    });
const LeftMenuDesktop_LazyLeftMenuDesktop = LeftMenuDesktop;
export default LeftMenuDesktop_LazyLeftMenuDesktop;
